import React, { Component } from 'react';
import DeviceDetector from "device-detector-js";

class Page extends Component {
  render() {
    const deviceDetector = new DeviceDetector();
    const userAgent = window.navigator.userAgent;
    const device = deviceDetector.parse(userAgent);
    console.dir(device);

    return (
      <>
        <div className="static">
          <header>
            <img src={process.env.PUBLIC_URL + '/global/images/logos/usa-logo.png'} className="logo" alt="University of St. Augustine" />
            <div id="serverName">{ device.device.type } - { device.os.name } - { device.client.name }</div>
          </header>
        </div>
      </>
    );
  }
}

export default Page;